import { combineReducers } from 'redux';
import customer from './headerReducer.js';
// import hospitalUser from './customerReducer';
import AccountDetails from './accountReducer.js';
import meDetails from './meStoreReducer.js';
import bootDetails from './bootReducer.js';
import modalPopup from './modalPopupReducer.js';
import wishList from './wishListReducer.js';
import notification from './notificationReducer.js';
import userDomInfo from './userDomInfoReducer.js';
import checkoutdata from './checkoutReducer.js';
import policyReducer from './policyReducer.js';
import returnsReducer from './returnsReducer.js';
import configurationReducer from './configurationReducer.js';
import formConfig from './formConfigReducer.js';
import templateReducer from './templateReducer.js';
import warrantyReducer from './warrantyReducer.js';
import salesOutReducer from './salesOutReducer.js';
import commonData from './commonData.js';
import inventoryCoreReducer from './inventoryCoreReducer.js';
export const reducers = {
    customer,
    AccountDetails,
    meDetails,
    bootDetails,
    modalPopup,
    wishList,
    notification,
    userDomInfo,
    checkoutdata,
    policyReducer,
    returnsReducer,
    configurationReducer,
    formConfig,
    templateReducer,
    warrantyReducer,
    salesOutReducer,
    commonData,
    inventoryCoreReducer
};

export default function rootReducer(asyncReducers) {
    return combineReducers({
        ...reducers,
        ...asyncReducers
    });
}